var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TheFooter"},[_c('footer',{staticClass:"text-center"},[_c('p',{staticClass:"text-base"},[_vm._v("Copyright © 2022, "),_c('a',{staticClass:"underline",attrs:{"href":"/"}},[_vm._v("Leaping Gibbon Sdn. Bhd.")])]),_c('a',{staticClass:"underline",attrs:{"href":"/"}},[_vm._v("201901032114 (1341444-T)")])])])
}]

export { render, staticRenderFns }